import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import qs from "qs";
import { VITE_API_URL } from "../utilities/env";
import type { RulesEngineStore } from "./store.tsx";

export const baseApiQuery = fetchBaseQuery({
  baseUrl: VITE_API_URL,
  timeout: 15000,
  paramsSerializer(params) {
    return qs.stringify(params, { allowDots: true });
  },
  prepareHeaders: (headers, { getState }) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
    const {
      auth: { token },
    } = getState() as RulesEngineStore;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});
